module.exports = {"$schema":"https://vega.github.io/schema/vega-lite/v2.json","data":{"url":"data/cars.json"},"mark":"bar","encoding":{"x":{"bin":{"maxbins":15},"field":"Horsepower","type":"quantitative"},"y":{"aggregate":"count","type":"quantitative"},"row":{"field":"Origin","type":"nominal"}}}


//////////////////
// WEBPACK FOOTER
// ./spec/vega-lite/trellis_bar_histogram.vl.json
// module id = 1655
// module chunks = 1